import { useQuery } from '@tanstack/react-query';
import type { VehicleSuggestionRequestResponse } from '@//app/api/suggestions/vehicle';
import { useApiBaseUrl } from '@//providers/MarketSettingsProvider';
import { httpClientGetJson } from '../httpClient';

const useVehicleSuggestions = (q: string) => {
  const apiBaseUrl = useApiBaseUrl();
  const query = useQuery<VehicleSuggestionRequestResponse>({
    queryKey: ['suggestionsContent', q],
    queryFn: async ({ signal }) => {
      const url = `${apiBaseUrl}/api/suggestions/vehicle?q=${q}`;
      return httpClientGetJson<VehicleSuggestionRequestResponse>(url, {
        signal,
      });
    },
    enabled: !!q,
    placeholderData: (d) => d,
  });

  return query;
};

export default useVehicleSuggestions;
